import styled from "@emotion/styled";

export const StyledPanel = styled.div`
  padding: 4rem;
  border-radius: 0.325rem;
  width: 100%;
  max-width: 75rem;

  margin-left: auto;
  margin-right: auto;
  background-color: ${(props) => props.theme.viewBackground};

  box-shadow: 0 0.59rem 1.17rem 0 rgba(0, 0, 0, 0.2);
`;
